import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router';
import { JobTabs } from '../../components/details/JobTabs';
import { IJobDetailsService } from '../../jobDetails.service';
import { withValidType } from './withValidType';

export const JobTabsContainer = withValidType(
  observer((): ReactElement => {
    const jobDetailsService = useInjection(IJobDetailsService.$);

    const { workspaceId, jobId } = useParams<{ jobId?: string; workspaceId: string }>();
    const {
      validationErrors,
      job: { type, variant },
      jobType,
    } = jobDetailsService.store;

    return (
      <JobTabs
        jobType={jobType}
        type={type}
        variant={variant}
        validationErrors={validationErrors}
        workspaceId={workspaceId}
        jobId={jobId}
      />
    );
  })
);
